import { takeEvery, takeLatest, call } from 'redux-saga/effects';

import { setSegmentPage, sendEventToSegment } from 'redux/modules/analytics';

import { PAGE_VIEW } from 'redux/modules/analytics/events';

function* handlePageNavigation() {
  yield call(setSegmentPage);

  const { href, pathname, search } = window.location;
  yield call(sendEventToSegment, PAGE_VIEW, {
    href,
    pathname,
    search,
  });
}

const savingTimes = {};

function* handlePerformanceTimings({ type, _moment, payload }) {
  if (_moment === 'start') {
    savingTimes[type] = window.performance.now();
    return;
  }

  if (_moment === 'end') {
    const before = savingTimes[type];
    const now = window.performance.now();
    const time = now - before;
    yield call(sendEventToSegment, type, { time, ...payload });
    delete savingTimes[type];
  }
}

export function* watchAnalytics() {
  yield takeLatest('@@router/LOCATION_CHANGE', handlePageNavigation);
  yield takeEvery((action) => !!action['@@performance'], handlePerformanceTimings);
}
